export default "<ion-app>\n\n<app-menu></app-menu>\n\n\n  <ion-router-outlet id=\"principal\"></ion-router-outlet>\n</ion-app>\n"